export default "/assets/images/mila-halo.png?a0858234ae012cfe5c1f5f0612c0046f";